export enum LobbyPreviewNav {
    Preview = 'Preview',
    MixTables = 'Mix Tables'
} 